import { useNetworkStatus } from '../offline/useOffline';

// تلميح دائم في رأس الصفحة: هل التطبيق متصل بالخادم أم يعمل على الجهاز.
export default function ConnectionStatus() {
  const offline = useNetworkStatus();

  const title = offline
    ? 'وضع أوفلاين: لا يوجد اتصال بالخادم. الفحوصات الجديدة تُحفظ على الجهاز وتُرفع عند عودة الاتصال.'
    : 'وضع أونلاين: متصل بالخادم، والفحوصات تُحفظ مباشرة فيه.';

  return (
    <span
      title={title}
      aria-label={title}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${
        offline ? 'border-amber-300 bg-amber-50 text-amber-800' : 'border-emerald-300 bg-emerald-50 text-emerald-700'
      }`}
    >
      <span className={`h-2 w-2 rounded-full ${offline ? 'bg-amber-500' : 'bg-emerald-500 animate-pulse'}`} />
      {offline ? 'أوفلاين' : 'أونلاين'}
    </span>
  );
}
